export default __webpack_public_path__ + "img/42cc16ad73761e3adc5709bde1db16f0.svg";